import { remarkVariablePlugin } from '@/utils/markdown';
import MDEditor from '@uiw/react-md-editor';

interface MarkdownRendererProps {
  source?: string;
  variables?: Record<string, string>;
  className?: string;
}

const MarkdownRenderer = ({
  source,
  variables = {},
  className,
}: MarkdownRendererProps) => {
  return (
    <MDEditor.Markdown
      source={source}
      className={className ?? '[&_*]:text-text-primary'}
      remarkPlugins={[remarkVariablePlugin(variables)]}
      components={{
        a: ({ node, ...props }) => (
          <a
            {...props}
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-200"
          />
        ),
      }}
    />
  );
};

export default MarkdownRenderer;
